import axiosInstance from "../../axiosInstance";

// Base URL cấu hình theo môi trường
// const BASE_URL = `${process.env.REACT_APP_API_URL || 'http://localhost:3001/api'}/classes`;

const BASE_URL = "/elearning/classes";

// Lấy danh sách tất cả các lớp học
export const getAllClasses = async (params = {}) => {
  try {
    const res = await axiosInstance.get(BASE_URL, { params });
    return res.data;
  } catch (error) {
    console.error("Error fetching all classes:", error);
    throw error;
  }
};

// ✅ Lấy danh sách lớp học cho học viên
export const getAllClassesForStudent = async (studentId) => {
  try {
    const response = await axiosInstance.get(`${BASE_URL}/${studentId}/classes`);
    return response.data;
  } catch (error) {
    console.error("Lỗi khi lấy danh sách lớp học cho học viên:", error);
    throw error;
  }
};

// Lấy thông tin 1 lớp theo ID
export const fetchClassById = async (id, options = {}) => {
  try {
    const res = await axiosInstance.get(`${BASE_URL}/${id}`, {
      skipGlobalErrorToast: Boolean(options.silent),
    });
    return res.data;
  } catch (error) {
    console.error(`Error fetching class with ID ${id}:`, error);
    throw error;
  }
};

// Lấy danh sách học viên theo lớp
export const fetchClassStudents = async (classId) => {
  try {
    const res = await axiosInstance.get(`${BASE_URL}/${classId}/students`);
    return res.data;
  } catch (error) {
    console.error(`Error fetching students of class ${classId}:`, error);
    throw error;
  }
};

// Tạo lớp học mới
export const createClass = async (data) => {
  try {
    const res = await axiosInstance.post(BASE_URL, data);
    return res.data;
  } catch (error) {
    console.error("Error creating class:", error);
    throw error;
  }
};

// Cập nhật lớp học
export const updateClass = async (id, data) => {
  try {
    const res = await axiosInstance.put(`${BASE_URL}/${id}`, data);
    return res.data;
  } catch (error) {
    console.error(`Error updating class with ID ${id}:`, error);
    throw error;
  }
};

// Xóa lớp học
export const deleteClass = async (id) => {
  try {
    const res = await axiosInstance.delete(`${BASE_URL}/${id}`);
    return res.data;
  } catch (error) {
    console.error("Lỗi khi xóa lớp học:", error);
    throw new Error(error.response?.data?.message || "Không thể xóa lớp học");
  }
};

export const getClassDeleteImpact = async (id) => {
  try {
    const res = await axiosInstance.get(`${BASE_URL}/${id}/delete-impact`);
    return res.data;
  } catch (error) {
    console.error("Lỗi khi tải tác động xóa lớp học:", error);
    throw new Error(
      error.response?.data?.message || "Không thể tải thông tin tác động khi xóa lớp học"
    );
  }
};

// Cập nhật trạng thái kích hoạt của lớp học
export const updateClassStatus = async (id, isActive) => {
  try {
    const res = await axiosInstance.patch(
      `${BASE_URL}/${id}/status`,
      { is_active: isActive }
    );
    return res.data;
  } catch (error) {
    console.error("Lỗi khi cập nhật trạng thái lớp học:", error);
    throw error;
  }
};

// Lấy danh sách đối tác trường học theo chi nhánh
export const getSchoolPartnersByBranch = async (branchId, keyword = "") => {
  try {
    const params = {};
    if (branchId) params.branch_id = branchId;
    if (keyword) params.keyword = keyword;
    const res = await axiosInstance.get(`${BASE_URL}/school-partners`, { params });
    return res.data;
  } catch (error) {
    console.error("Error fetching school partners:", error);
    throw error;
  }
};

// Import hàng loạt lớp học từ file Excel (.xlsx, .xls) hoặc CSV
export const importClassesFromExcel = async (file) => {
  try {
    const formData = new FormData();
    formData.append("file", file);
    const res = await axiosInstance.post(`${BASE_URL}/import`, formData, {
      headers: { "Content-Type": "multipart/form-data" },
      timeout: 120_000,
    });
    return res.data;
  } catch (error) {
    console.error("Error importing classes from file:", error);
    throw error;
  }
};

// Export CSV từ backend
export const exportClassesCSV = async () => {
  try {
    const res = await fetch(`${BASE_URL}/export`, {
      method: "GET",
      credentials: "include"
    });

    if (!res.ok) throw new Error("Export CSV thất bại.");
    return await res.blob();
  } catch (error) {
    console.error("Lỗi khi export CSV:", error);
    throw error;
  }
};
